import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "What is SecureFlex security patrol management software?",
    a: "SecureFlex is an advanced, cloud-based security patrol management platform designed for modern security companies. It uses real-time GPS tracking, AI-powered incident analysis, and biometric face verification to ensure guard accountability and provide site owners with verified patrol data."
  },
  {
    q: "How does GPS geofencing work for security patrols?",
    a: "Our GPS geofencing technology creates a virtual boundary around each checkpoint. Officers must be physically within this configurable radius to perform a verified check-in, eliminating 'ghost patrols' and ensuring comprehensive site coverage."
  },
  {
    q: "Do I need special hardware to use SecureFlex?",
    a: "No special hardware or dedicated scanners are required. SecureFlex works on any standard smartphone (iOS and Android), significantly reducing deployment costs for security operations of all sizes."
  },
  {
    q: "What is AI incident analysis in security reporting?",
    a: "SecureFlex uses natural language processing to analyze guard-reported incidents. When an officer describes a situation, the AI categorizes the severity, identifies the incident type, and suggests immediate response protocols based on industry best practices."
  },
  {
    q: "Is SecureFlex suitable for multiple security sites?",
    a: "Absolutely. SecureFlex features a robust multi-site dashboard that allows business owners and security managers to monitor patrols across dozens or even hundreds of locations from a single, centralized command center."
  }
];

const FAQSection = () => {
  return (
    <section id="faq" className="py-24 bg-secondary/20">
      <div className="mx-auto max-w-4xl px-6">
        <p className="text-sm font-semibold tracking-widest text-primary text-center">Common Questions</p>
        <h2 className="mt-2 text-3xl font-bold md:text-5xl text-center">FREQUENTLY ASKED QUESTIONS</h2>
        <div className="mt-12">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border rounded-xl bg-card px-6">
                <AccordionTrigger className="text-left font-bold hover:no-underline py-6">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-6 leading-relaxed">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* FAQ Structured Data for SEO */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqs.map(faq => ({
              "@type": "Question",
              "name": faq.q,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.a
              }
            }))
          })}
        </script>
      </div>
    </section>
  );
};

export default FAQSection;
